import { render, staticRenderFns } from "./FilterStatuses.vue?vue&type=template&id=2a212715&"
import script from "./FilterStatuses.vue?vue&type=script&lang=js&"
export * from "./FilterStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports